import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { SharedModule } from './../../components/shared.module';

import { EditAccountComponent } from './editAccount.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [
    EditAccountComponent
  ],
  imports: [
    SharedModule,
    TranslateModule,
    BrowserModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule
  ],
  exports: [
    EditAccountComponent
  ]
})

export class OptionsModule { }



// WEBPACK FOOTER //
// ./src/app/views/options/options.module.ts